import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { AppInsightsService } from '@core/services/app-insights/app-insights';
import { isManagedApiUrl } from '@core/utils/api-url';
import { generateSpanId, generateTraceId } from '@core/utils/trace';
import { environment } from '@environment/environment';

export function traceInterceptorFn(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (isManagedApiUrl(req.url, environment.apiUrl)) {
    // Reuse App Insights' current operation trace id (falling back to a fresh id) so the client
    // telemetry and the backend trace correlate on one operation id.
    const traceId = inject(AppInsightsService).getOperationTraceId() ?? generateTraceId();
    const traceparent = `00-${traceId}-${generateSpanId()}-01`;
    const tracedReq = req.clone({
      setHeaders: { traceparent }
    });
    return next(tracedReq);
  }
  return next(req);
}
